/**
 * Escolhe o menu do shell conforme a rota — tenant vs Super Admin (DOC 09 § 4).
 *
 * **Proibido** chamar fora do render React (useEffect, setTimeout, click handler, etc.).
 * `LayoutMenuData` / `SuperAdminMenuData` usam hooks — chamar como função fora do render
 * → React #321 (tela branca no painel). Ver DOC 09 § 7.3.
 */
import tenantNavdata from "./LayoutMenuData";
import saNavdata from "./SuperAdminMenuData";

export const resolveShellNavdata = (pathname: string) => {
  const isSa = pathname.startsWith("/super-admin");
  const nav = isSa ? saNavdata : tenantNavdata;
  return nav().props.children;
};
